import styled from 'styled-components'

const StyledAuthView = styled.div`
  min-height: 100vh;
  display: grid;
  align-content: center;

  .auth-form {
    border-radius: 10px;
    box-shadow:
      0 1px 1px hsl(0deg 0% 0% / 0.015),
      0 2px 2px hsl(0deg 0% 0% / 0.015),
      0 4px 4px hsl(0deg 0% 0% / 0.015),
      0 8px 8px hsl(0deg 0% 0% / 0.015),
      0 16px 16px hsl(0deg 0% 0% / 0.015)
    ;
    background-color: ${({ theme }) => theme.color.background};
    padding: 20px;
    position: relative;
    z-index: 1;

    h1 {
      font-weight: 500;
      font-size: 26px;
      user-select: none;
      color: ${({ theme }) => theme.color.gray[800]};
    }

    form {
      display: grid;
      grid-gap: 20px;
      margin: 34px 0 40px 0;

      .input-container {
        .input-label {
          font-weight: 500;
          font-size: 15px;
          user-select: none;
          color: ${({ theme }) => theme.color.gray[500]};
        }

        .input {
          position: relative;
          margin-top: 10px;

          svg {
            position: absolute;
            height: 20px;
            top: 50%;
            pointer-events: none;
            left: 10px;
            transform: translateY(-50%);
            color: ${({ theme }) => theme.color.gray[400]};

            path {
              stroke-width: 1.75px;
            }
          }

          input {
            width: 100%;
            box-sizing: border-box;
            background-color: ${({ theme }) => theme.color.gray[100]};
            color: ${({ theme }) => theme.color.gray[900]};
            padding: 0 12px 0 40px;
            height: 42px;
            border-radius: 6px;
            transition: 0.2s;

            &::placeholder {
              user-select: none;
              color: ${({ theme }) => theme.color.gray[400]};
            }
          }

          &:focus-within {
            input {
              box-shadow: rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 12%) 0px 1px 1px 0px, rgb(64 68 82 / 16%) 0px 0px 0px 1px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(64 68 82 / 8%) 0px 2px 5px 0px;
              background-color: ${({ theme }) => theme.color.background};
            }
          }
        }
      }
    }

    button {
      width: 100%;
      box-sizing: border-box;
      background-color: ${({ theme }) => theme.color.blue[600]};
      color: ${({ theme }) => theme.color.background};
      padding: 0 12px;
      height: 42px;
      display: flex;
      font-weight: 500;
      border-radius: 6px;
      justify-content: center;
      align-items: center;
      transition: 0.2s;
      user-select: none;
      box-shadow:
        0 1px 1px hsl(0deg 0% 0% / 0.045),
        0 2px 2px hsl(0deg 0% 0% / 0.045),
        0 4px 4px hsl(0deg 0% 0% / 0.045)
      ;

      svg {
        position: relative;
        top: -1px;
        height: 20px;
        margin-right: 8px;
      }

      .spinner {
        svg {
          top: 0;
          fill: ${({ theme }) => theme.color.gray[400]};
        }
      }

      &:hover {
        background-color: ${({ theme }) => theme.color.blue[700]};
      }

      &:disabled {
        box-shadow: none;
        background-color: ${({ theme }) => theme.color.gray[100]};
        color: ${({ theme }) => theme.color.gray[400]};

        &:hover {
          cursor: not-allowed;
        }
      }

      &.submit-btn {
        text-shadow: 1px 1px rgb(0, 0, 0, 0.05);
      }
    }

    .auth-prompt {
      display: block;
      text-align: center;
      margin-top: 12px;
      font-size: 15px;
      user-select: none;
      color: ${({ theme }) => theme.color.gray[500]};

      a {
        outline: none;
        color: ${({ theme }) => theme.color.blue[500]};
        font-weight: 500;

        &:focus-visible {
          color: ${({ theme }) => theme.color.blue[600]};
        }
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.s}px) {
    background-color: ${({ theme }) => theme.color.gray[100]};
    
    .auth-form {
      padding: 40px;
      margin: 0 auto;
      max-width: 425px;
      width: 100%;
    }
  }
`

export default StyledAuthView
